<template>
  <div class="create">
    <MyHeader title="创建商品" :before-go-back="checkBeforeGoBack"></MyHeader>
    <div class="picture">
      <div class="uploader-container">
        <div class="uploader-title">商品主图</div>
        <van-uploader
          data-sequence="1"
          v-model="fileList"
          multiple
          deletable
          :max-count="9"
          :after-read="uploadForImg"
          @delete="deleteImg"
          :before-read="beforeUpload"
        >
          <div class="uploader-box">
            <img src="@/assets/img/my/add-icon.png" class="add-icon" />
            <p class="text">上传({{ imgLength }}/9)</p>
          </div>
        </van-uploader>
        <div v-if="isUpload">正在上传中,请稍后...</div>
      </div>
      <div class="uploader-container">
        <div class="uploader-title">商品视频</div>
        <van-uploader
          v-model="videoList"
          accept="video/*"
          deletable
          :max-count="1"
          :after-read="uploadForVideo"
          @delete="deleteVideo"
          :before-read="beforeUpload"
          :max-size="100 * 1024 * 1024"
          @oversize="onOversize"
        >
          <div class="uploader-box">
            <img src="@/assets/img/my/add-icon.png" class="add-icon" />
            <p class="text">上传({{ videoLength }}/1)</p>
          </div>
        </van-uploader>
      </div>
    </div>
    <div class="picture">
      <div class="title">基本信息 &nbsp;(*号必填)</div>

      <van-field
        data-sequence="2"
        v-model="productCategory"
        label="商品类别"
        placeholder="请输入商品类别"
        @click.stop="jumpCategory"
        v-show="type == 2"
      >
        <template #right-icon>
          <div class="category">
            添加
            <van-icon name="arrow-down" />
          </div>
        </template>
      </van-field>
      <van-field v-model="productId" label="商品编码" placeholder="请输入商品编码">
        <template #right-icon>
          <div class="scan" @click="scan">扫码录入</div>
        </template>
      </van-field>
      <van-field
        data-sequence="3"
        v-model="productName"
        label="商品名称 *"
        placeholder="请输入商品名称"
      >
        <template #right-icon>
          <img
            src="@/assets/img/my/show-icon.png"
            class="show-icon"
            @click="switchIcon(3)"
            v-if="IsproductName"
          />
          <img
            src="@/assets/img/my/hidden-icon.png"
            class="show-icon"
            @click="switchIcon(3)"
            v-else
          />
        </template>
      </van-field>
      <van-field
        data-sequence="4"
        v-model="productSize"
        label="商品规格"
        type="text"
        placeholder="请输入商品规格"
      >
        <template #right-icon>
          <img
            src="@/assets/img/my/show-icon.png"
            class="show-icon"
            @click="switchIcon(6)"
            v-if="IsproductSize"
          />
          <img
            src="@/assets/img/my/hidden-icon.png"
            class="show-icon"
            @click="switchIcon(6)"
            v-else
          />
        </template>
      </van-field>
      <van-field
        data-sequence="5"
        @input="onInput"
        v-model="productUnit"
        label="单位 *"
        placeholder="请输入单位"
      >
        <template #right-icon>
          <img
            src="@/assets/img/my/show-icon.png"
            class="show-icon"
            @click="switchIcon(7)"
            v-if="IsproductUnit"
          />
          <img
            src="@/assets/img/my/hidden-icon.png"
            class="show-icon"
            @click="switchIcon(7)"
            v-else
          />
        </template>
      </van-field>

      <div class="field-box">
        <van-field
          data-sequence="6"
          v-model="productCosts"
          label="成本价"
          type="number"
          placeholder="请输入"
          class="field-item"
        >
          <!-- <template #right-icon>
            <div class="category">元</div>
          </template> -->
        </van-field>
        <van-field
          data-sequence="7"
          v-model="productPrice"
          label="售价"
          type="number"
          placeholder="请输入"
          class="field-item"
        >
          <template #right-icon>
            <img
              src="@/assets/img/my/show-icon.png"
              class="show-icon"
              @click="switchIcon(5)"
              v-if="IsproductPrice"
            />
            <img
              src="@/assets/img/my/hidden-icon.png"
              class="show-icon"
              @click="switchIcon(5)"
              v-else
            />
          </template>
        </van-field>
      </div>
      <div class="field-box">
        <van-field
          data-sequence="8"
          v-model="productStock"
          label="实物库存"
          type="number"
          placeholder="请输入"
          class="field-item"
        />
        <van-field
          data-sequence="9"
          v-model="productOrderStock"
          label="订单库存"
          type="number"
          placeholder="请输入"
          class="field-item"
        >
          <template #right-icon>
            <img
              src="@/assets/img/my/show-icon.png"
              class="show-icon"
              @click="switchIcon(8)"
              v-if="IsproductStock"
            />
            <img
              src="@/assets/img/my/hidden-icon.png"
              class="show-icon"
              @click="switchIcon(8)"
              v-else
            />
          </template>
        </van-field>
      </div>
      <div class="field-box">
        <van-field
          v-model="productHighest"
          label="最高库存"
          type="number"
          placeholder="请输入"
          class="field-item"
        />
        <van-field
          v-model="productMin"
          label="最低库存"
          type="number"
          placeholder="请输入"
          class="field-item"
        />
      </div>

      <div class="product-desc">
        <van-cell title="商品介绍">
          <template #right-icon>
            <img
              src="@/assets/img/my/show-icon.png"
              class="show-icon"
              @click="switchIcon(4)"
              v-if="IsproductDesc"
            />
            <img
              src="@/assets/img/my/hidden-icon.png"
              class="show-icon"
              @click="switchIcon(4)"
              v-else
            />
          </template>
        </van-cell>
        <my-quill-editor
          v-model="productDesc"
          :store-id="storeId"
          :uploading="localUploading"
          ref="quillEditorRef"
          @update:uploading="updateUploading"
        ></my-quill-editor>
      </div>

      <van-field
        v-model="firstText"
        label="平台一级分类"
        readonly
        placeholder="请选择商品类别"
        @click="firstType"
        v-show="type == 1"
      >
        <template #right-icon>
          <div class="category" @click.stop="">
            <van-icon name="arrow-down" />
          </div>
        </template>
      </van-field>
      <van-field
        v-model="secText"
        label="平台二级分类"
        readonly
        placeholder="请选择商品类别"
        @click="secType"
        v-show="type == 1"
      >
        <template #right-icon>
          <div class="category" @click.stop="">
            <van-icon name="arrow-down" />
          </div>
        </template>
      </van-field>

      <!-- // 一二级分类弹出层 -->
      <van-popup v-model="showFirst" round position="bottom">
        <van-picker
          show-toolbar
          :columns="firstList"
          @cancel="showFirst = false"
          @confirm="onConfirm"
        />
      </van-popup>

      <van-popup v-model="showSec" round position="bottom">
        <van-picker
          show-toolbar
          :columns="secList"
          @cancel="showSec = false"
          @confirm="onConfirmSec"
        />
      </van-popup>
    </div>

    <div class="picture">
      <div class="title">库位信息</div>
      <div class="warehouse">
        <van-field v-model="warehouseText" label="库位" placeholder="请输入库位">
          <template #right-icon>
            <img
              src="@/assets/img/my/show-icon.png"
              class="show-icon"
              @click="switchIcon(1)"
              v-if="IswarehouseText"
            />
            <img
              src="@/assets/img/my/hidden-icon.png"
              class="show-icon"
              @click="switchIcon(1)"
              v-else
            />
          </template>
        </van-field>
      </div>
      <div class="uploader-header">
        库位图片
        <img
          src="@/assets/img/my/show-icon.png"
          class="show-icon"
          @click="switchIcon(2)"
          v-if="IswarehouseList"
        />
        <img
          src="@/assets/img/my/hidden-icon.png"
          class="show-icon"
          @click="switchIcon(2)"
          v-else
        />
      </div>
      <van-uploader
        v-model="warehouseList"
        deletable
        :max-count="9"
        :after-read="uploadForWarehouse"
        @delete="deleteWarehouse"
        :before-read="beforeUpload"
      >
        <div class="uploader-box">
          <img src="@/assets/img/my/add-icon.png" class="add-icon" />
          <p class="text">上传({{ warehouseLength }}/9)</p>
        </div>
      </van-uploader>
    </div>

    <div class="foot">
      <p class="switch-btn" @click="focusNextField">快速维护</p>
      <p class="bt" @click="saveProduct">保存商品</p>
    </div>
  </div>
</template>

<script>
import api from '../../utils/api';
import { aGet, aPost, upImg2, aPost2 } from '../../utils/request';
import MyHeader from '../../components/MyHeader/MyHeader.vue';
import { Dialog, Toast } from 'vant';
import MyQuillEditor from '../../components/MyQuillEditor/MyQuillEditor.vue';
import { uploadFile } from '../../api/upload';
export default {
  components: { MyQuillEditor, MyHeader },
  name: 'CreateProduct',
  data() {
    return {
      vueAppTypeName: process.env.VUE_APP_TYPE_NAME || '',
      localUploading: this.uploading, // **本地存储上传状态**
      fieldsEls: [], // 存放按照 sequence 排序好的元素列表
      currentIndex: 0, // 当前聚焦的索引
      quillEditorRef: null,
      editorOptions: {
        placeholder: '请输入你的内容',
      },
      fileList: [],
      urlParma: [],
      videoList: [],
      videoParma: [],
      warehouseList: [],
      warehouseParma: [],
      // 库位
      IswarehouseList: true,
      warehouseText: '',
      IswarehouseText: true,
      // 商品编码
      productId: '',
      IsproductId: true,
      // 商品名称
      productName: '',
      IsproductName: true,
      // 商品介绍
      productDesc: '',
      IsproductDesc: true,
      // 售价
      productPrice: '',
      IsproductPrice: true,
      // 商品规格
      productSize: '',
      IsproductSize: true,
      // 单位
      productUnit: '',
      IsproductUnit: true,
      // 订单库存
      productOrderStock: '',
      IsproductStock: true,
      // 实物库存
      productStock: '',
      // 成本价
      productCosts: '',
      // 类别
      productCategory: '',
      productCateId: '',
      //最高价
      productHighest: '',
      // 最低价
      productMin: '',
      type: JSON.parse(localStorage.getItem('type')),
      storeId: JSON.parse(localStorage.getItem('storeId')),
      typeList: [],
      // 一级分类
      showFirst: false,
      firstList: [],
      firstText: '',
      // 二级分类
      secList: [],
      showSec: false,
      secText: '',
      isUpload: true,
      isEdited: false,
    };
  },
  computed: {
    imgLength() {
      return this.fileList.length;
    },
    videoLength() {
      return this.videoList.length;
    },
    warehouseLength() {
      return this.warehouseList.length;
    },
  },

  methods: {
    updateUploading(newVal) {
      this.localUploading = newVal; // **更新自身**
      //this.$emit("update:uploading", newVal); // **同步回 `ProductForm.vue`**
    },
    focusNextField() {
      let nextSeq = this.currentIndex + 1;
      if (nextSeq >= 10) {
        nextSeq = 1;
      }
      console.log('----------', nextSeq);
      let attempts = 8;

      while (attempts > 0) {
        const inputEl = document.querySelector(`[data-sequence="${nextSeq}"]`);
        if (!inputEl) {
          break;
        }

        const isVisible = inputEl.offsetParent !== null;
        if (isVisible) {
          console.log('==========111111111111', nextSeq);
          // 这里 inputEl 就是 <input> 本身，不需要再querySelector
          inputEl.focus();
          this.currentIndex = nextSeq;
          return;
        } else {
          console.log('==========2222222222');
        }

        nextSeq++;
        attempts--;
      }
    },
    onEditorBlur() {
      console.log('blur', this.messages);
    },

    onEditorFocus() {
      console.log('focus', this.messages);
    },

    onEditorReady(quill, event) {
      console.log('ready', quill, event);
      this.quillEditorRef = quill;
      const toolbar = quill.getModule('toolbar');
      toolbar.addHandler('image', this.imageHandler);
    },
    imageHandler(value) {
      if (value) {
        // 创建文件选择输入框
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.click();
        input.onchange = () => {
          const file = input.files[0];
          if (file) {
            // 使用 upImg2 上传图片
            upImg2(api.upload, { file })
              .then(res => {
                console.log('上传图片成功:', res.data);
                const url = res.data.url;
                console.log('url:', url);
                const range = this.quillEditorRef.getSelection();
                this.quillEditorRef.insertEmbed(range.index, 'image', url);
                this.quillEditorRef.setSelection(range.index + 1);
              })
              .catch(error => {
                console.error('Upload failed:', error);
              });
          }
        };
      } else {
        // 插入图片链接
        const url = prompt('Enter the image URL here:');
        if (url) {
          const range = this.quillEditorRef.getSelection();
          this.quillEditorRef.insertEmbed(range.index, 'image', url);
          this.quillEditorRef.setSelection(range.index + 1);
        }
      }
    },
    checkBeforeGoBack() {
      if (this.isEdited) {
        // 返回一个 Promise 来处理异步逻辑
        return Dialog.confirm({
          title: '未保存的数据',
          message: '您已编辑了数据，但尚未保存。确定要离开吗？',
        })
          .then(() => {
            this.resetFormData();
            return true;
          })
          .catch(() => {
            return false;
          });
      } else {
        return true;
      }
    },
    onInput() {
      this.isEdited = true;
    },
    //上传限制
    onOversize(file) {
      console.log(file);
      this.$toast('文件大小不能超过 100M');
    },
    switchIcon(value) {
      if (value == 1) {
        this.IswarehouseText = !this.IswarehouseText;
      }
      if (value == 2) {
        this.IswarehouseList = !this.IswarehouseList;
      }
      if (value == 3) {
        this.IsproductName = !this.IsproductName;
      }
      if (value == 4) {
        this.IsproductDesc = !this.IsproductDesc;
      }
      if (value == 5) {
        this.IsproductPrice = !this.IsproductPrice;
      }
      if (value == 6) {
        this.IsproductSize = !this.IsproductSize;
      }
      if (value == 7) {
        this.IsproductUnit = !this.IsproductUnit;
      }
      if (value == 8) {
        this.IsproductStock = !this.IsproductStock;
      }
    },

    scan() {
      this.$router.push({
        path: '/scanformy',
      });
    },

    // 类别
    jumpCategory() {
      this.$router.push({
        path: '/Category',
      });
    },
    // 商品
    saveProduct() {
      let that = this;
      console.log(this.isUpload);
      // console.log('1',JSON.stringify());
      if (this.isUpload === true) {
        this.$toast('图片上传中，请稍等！');
        return;
      }
      if (this.firstText == '' && JSON.stringify(this.secText) == '') {
        this.$toast('分类不能为空！');
        return;
      }
      if (this.productName == '') {
        this.productName = '未命名商品';
      }
      if (this.productUnit == '') {
        this.productUnit = '未命名单位';
      }

      // if(this.productSize == '') {
      //   this.$toast('商品规格不能为空！')
      //   return
      // }
      if (this.type == 1) {
        let firstId = this.typeList.filter(item => item.firstTypeName == this.firstText);
        console.log('aa', firstId);
        console.log(
          'ssss',
          this.typeList.filter(item => item.firstTypeName == this.firstText)[0].firstTypeId
        );
        console.log(
          'aaaaaa ',
          this.typeList
            .filter(item => item.firstTypeName == this.firstText)[0]
            .secondTypes.filter(item => item.secondTypeName == this.secText).secondTypeId
        );
        let secId = firstId[0].secondTypes.filter(item => item.secondTypeName == this.secText);
        console.log(firstId);
      }

      let tProduct = {
        platformFirstTypeId:
          this.type == 2
            ? ''
            : this.typeList.filter(item => item.firstTypeName == this.firstText)[0].firstTypeId,
        platformFirstTypeName: this.type == 2 ? '' : this.firstText,
        platformSecondTypeId:
          this.type == 2
            ? ''
            : this.typeList
                .filter(item => item.firstTypeName == this.firstText)[0]
                .secondTypes.filter(item => item.secondTypeName == this.secText).secondTypeId,
        platformSecondTypeName: this.type == 2 ? '' : this.secText,

        // platformFirstTypeId: this.type == 2 ? firstId[0].firstTypeId:'',
        // platformFirstTypeName: this.type == 2 ? this.firstText:'',
        // platformSecondTypeId: this.type == 2 ?secId[0].secondTypeId:'',
        // platformSecondTypeName: this.type == 2 ? this.secText: '',
        productCode: this.productId,
        productName: this.productName,
        productNameShow: this.IsproductName == true ? 1 : 2,
        productSpec: this.productSize,
        productSpecShow: this.IsproductSize == true ? 1 : 2,
        productUnit: this.productUnit,
        productUnitShow: this.IsproductUnit == true ? 1 : 2,
        productArea: this.warehouseText,
        productAreaImg: this.warehouseParma.join(','),
        productAreaImgShow: this.IswarehouseList == true ? 1 : 2,
        productAreaShow: this.IswarehouseText == true ? 1 : 2,
        productCostPrice: this.productCosts,
        productImgs: this.urlParma.join(','),
        productIntroduction: this.productDesc,
        productIntroductionShow: this.IsproductDesc == true ? 1 : 2,
        productMaxStock: this.productHighest,
        productMinStock: this.productMin,
        productOrderStock: this.productOrderStock,
        productKindStock: this.productStock,
        productOrderStockShow: this.IsproductStock == true ? 1 : 2,
        productSellPrice: this.productPrice,
        productSellPriceShow: this.IsproductPrice == true ? 1 : 2,
        productVideo: this.videoParma.join(','),
        storeId: this.storeId,
        storeIdentity: this.type,
        productShowType: 1,
        productTypeId: this.productCateId,
        productTypeName: this.productCategory,
      };
      tProduct = JSON.stringify(tProduct);
      console.log(tProduct);
      let parma = {
        tProduct: tProduct,
      };
      console.log('11111', parma);
      aPost(api.saveProduct, parma).then(res => {
        this.$toast(res.data.msg);
        console.log('商品', res);
        that.isEdited = false;
        this.$router.replace({
          path: '/Exhibition',
        });
      });
    },
    // 获取平台分类
    getPlatformProductType() {
      aGet(api.getPlatformProductType).then(res => {
        console.log('平台分类', res);
        // console.log(this.secondTypes);
        this.typeList = res.data.typeList;
        this.firstList = res.data.typeList.map(item => item.firstTypeName);
        // this.typeList = res.data.typeList.map(item => item.secondTypes.map(pitem => pitem.secondTypeName))
        // for(let i = 0; i < this.firstText.length; i++) {
        //   this.firstList[i].push(this.typeList[i])
        // }
        // console.log(this.firstList);
        // console.log(this.typeList);
      });
    },
    // 一级分类
    firstType() {
      this.showFirst = true;
    },
    // 一级分类确认按钮
    onConfirm(picker) {
      this.secList = this.typeList.filter(item => item.firstTypeName == picker);
      this.secList = this.secList[0].secondTypes.map(item => item.secondTypeName);
      this.firstText = picker;
      console.log(this.secList);
      this.showFirst = false;
      this.showSec = true;
    },
    // 二级分类确认按钮
    onConfirmSec(picker) {
      this.secText = picker;
      this.showSec = false;
    },
    secType() {
      this.showSec = true;
    },

    /**
     * 上传图片
     * @param {File|File[]} file - 要上传的文件或文件数组
     */
    async uploadForImg(file) {
      const files = Array.isArray(file) ? file : [file];
      this.isUpload = true; // 修改本地状态
      this.$emit('update:uploading', this.isUpload);

      try {
        // 使用 Promise.all 实现并行上传，提高上传效率
        const uploadPromises = files.map(singleFile => {
          const fileToUpload = singleFile.file || singleFile;

          if (!(fileToUpload instanceof File)) {
            console.error(`上传的对象不是 File 类型: ${fileToUpload}`);
            Toast.fail('上传失败，文件类型错误');
            return Promise.resolve(); // 返回空 Promise 继续处理
          }

          return uploadFile(this.storeId, fileToUpload, this.updateUploadProgress)
            .then(response => {
              if (response.code === 0) {
                const imageUrl = response.url;
                this.urlParma.push(imageUrl);
              } else {
                Toast.fail(response.message || '部分图片上传失败');
              }
            })
            .catch(error => {
              console.error('上传发生异常：', error);
              Toast.fail('上传异常');
            });
        });

        // 等待所有图片上传完成
        await Promise.all(uploadPromises);
        Toast.clear();
        Toast.success('上传完成');
      } finally {
        this.isUpload = false; // 修改本地状态
        this.$emit('update:uploading', this.isUpload);
      }
    },
    // 图片信息
    uploadForImgOrigin() {
      console.log(this.fileList);
      let parma = {
        storeId: this.storeId,
        file: this.fileList[0].file,
      };
      console.log(parma);
      upImg2(api.upload, parma).then(res => {
        console.log('图片信息', res);
        if (res.data.code == 0) {
          this.isUpload = true;
          this.urlParma.push(res.data.url);
        }
        console.log(this.urlParma);
      });
    },
    // 视频信息
    uploadForVideo() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      let parma = {
        storeId: this.storeId,
        file: this.videoList[0].file,
      };
      console.log(parma);
      upImg2(api.upload, parma).then(res => {
        console.log('视频信息', res);
        Toast.clear();
        if (res.data.code == 0) {
          this.$toast('视频上传成功');
          this.isUpload = true;
          this.videoParma.push(res.data.url);
        }
        console.log(this.videoParma);
      });
    },
    // 库位图片
    uploadForWarehouse() {
      let parma = {
        storeId: this.storeId,
        file: this.warehouseList[0].file,
      };
      console.log(parma);
      upImg2(api.upload, parma).then(res => {
        console.log('库位信息', res);
        this.isUpload = true;
        this.warehouseParma.push(res.data.url);
        console.log(this.warehouseParma);
      });
    },
    // 删除图片
    deleteImg(file, detail) {
      let parma = {
        url: this.urlParma[detail.index],
      };
      aPost(api.deleteImg, parma).then(res => {
        this.$toast(res.data.msg);
        console.log('删除图片', res);
        this.urlParma.splice(detail.index, 1);
        console.log(this.urlParma);
      });
    },

    deleteVideo(file, detail) {
      console.log(this.videoParma);
      let parma = {
        url: this.videoParma[detail.index],
      };
      aPost(api.deleteImg, parma).then(res => {
        this.$toast(res.data.msg);
        console.log('删除图片', res);
        this.videoParma.splice(detail.index, 1);
      });
    },
    deleteWarehouse(file, detail) {
      let parma = {
        url: this.warehouseParma[detail.index],
      };
      aPost(api.deleteImg, parma).then(res => {
        this.$toast(res.data.msg);
        console.log('删除图片', res);
        if (res.data.code == 0) {
          this.warehouseParma.splice(detail.index);
        }
      });
    },
    beforeUpload() {
      console.log(this.isUpload);
      this.isUpload = true;
      return true;
    },
    getTypeName() {
      if (
        localStorage.getItem('typeName') != undefined ||
        localStorage.getItem('typeName') != null
      ) {
        this.productCategory = localStorage.getItem('typeName');
        this.productCateId = localStorage.getItem('typeid');
        localStorage.removeItem('typeName');
        localStorage.removeItem('typeid');
      }
    },
  },

  activated() {
    console.log('触发了');
    this.getTypeName();
  },
  // deactivated() {
  //   console.log('我是deactivated');
  // },
  beforeRouteLeave(to, from, next) {
    if (to.path == '/Exhibition') {
      from.meta.keepAlive = true;
      (this.fileList = []),
        (this.urlParma = []),
        (this.videoList = []),
        (this.videoParma = []),
        (this.warehouseList = []),
        (this.warehouseParma = []),
        // 库位
        (this.IswarehouseList = true),
        (this.warehouseText = ''),
        (this.IswarehouseText = true),
        // 商品编码
        (this.productId = ''),
        (this.IsproductId = true),
        // 商品名称
        (this.productName = ''),
        (this.IsproductName = true);
      // 商品介绍
      (this.productDesc = ''),
        (this.IsproductDesc = true),
        // 售价
        (this.productPrice = ''),
        (this.IsproductPrice = true),
        // 商品规格
        (this.productSize = ''),
        (this.IsproductSize = true),
        // 单位
        (this.productUnit = ''),
        (this.IsproductUnit = true),
        // 订单库存
        (this.productOrderStock = ''),
        (this.IsproductStock = true),
        // 实物库存
        (this.productStock = ''),
        // 成本价
        (this.productCosts = ''),
        // 类别
        (this.productCategory = ''),
        (this.productCateId = ''),
        //最高价
        (this.productHighest = ''),
        // 最低价
        (this.productMin = ''),
        (this.type = JSON.parse(localStorage.getItem('type'))),
        (this.storeId = JSON.parse(localStorage.getItem('storeId'))),
        (this.typeList = []),
        // 一级分类
        (this.showFirst = false),
        (this.firstList = []),
        (this.firstText = ''),
        // 二级分类
        (this.secList = []),
        (this.showSec = false),
        (this.secText = ''),
        (this.isUpload = true);
      // this.$
    }
    if (to.path == '/Category') {
      from.meta.keepAlive = false;
    }
    console.log(to.path, from.meta.keepAlive);
    next();
  },
  mounted() {
    // 获取页面中所有有 data-sequence 的元素
    let allFields = Array.from(document.querySelectorAll('[data-sequence]'));
    console.log(allFields);

    // 按照data-sequence排序
    allFields.sort((a, b) => {
      const seqA = parseInt(a.dataset.sequence, 10);
      const seqB = parseInt(b.dataset.sequence, 10);
      return seqA - seqB;
    });

    this.fieldsEls = allFields;

    this.getPlatformProductType();
    if (localStorage.getItem('codeUrl') != undefined || localStorage.getItem('codeUrl') != null) {
      this.productId = localStorage.getItem('codeUrl');
      localStorage.removeItem('codeUrl');
    }
  },
};
</script>

<style lang="scss" scoped>
.field-box {
  display: flex;
  justify-content: space-between;
  /deep/ .van-field__label {
    width: 150px;
  }
}
.field-item {
  flex: 1;
  margin-right: 10px;
}

.field-item:last-child {
  margin-right: 0;
}

.create {
  background: #f2f5f3;
  min-height: 100%;
  padding-bottom: 150px;
  // height: 100%;
  // .container {
  //   height:calc(86%);
  //   overflow: auto;
  //   width: 100%;
  // }
  .picture {
    width: 702px;
    // height: 447px;
    background: #ffffff;
    opacity: 1;
    border-radius: 20px;
    margin-left: 24px;
    margin-top: 24px;
    padding: 32px 20px;
    padding-top: 0;

    .title {
      font-size: 32px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      line-height: 46px;
      color: #222222;
      padding-top: 32px;
    }

    /deep/ .van-picker__cancel {
      height: 100px;
      width: 150px;
      font-size: medium;
    }

    /deep/ .van-picker__confirm {
      height: 100px;
      width: 150px;
      font-size: medium;
    }

    .van-uploader {
      margin-top: 32px;
      width: 100%;
    }

    /deep/ .van-uploader__preview {
      width: 212px;
      height: 212px;
      background: #f2f5f3;
      opacity: 1;
      border-radius: 10px;
    }

    /deep/ .van-uploader__preview-image {
      width: 100%;
      height: 100%;
    }

    /deep/ .van-uploader__preview-delete {
      width: 48px;
      height: 48px;
    }

    /deep/ .van-image__img {
      width: 212px;
      height: 212px;
      background: #b9b9b9;
      opacity: 1;
      border-radius: 10px;
    }

    /deep/ .van-uploader__preview-delete-icon {
      font-size: 55px;
    }

    .show-icon {
      width: 30px;
      height: 30px;
      margin-top: 5px;
    }

    .category {
      display: inline-flex;
      font-size: 32px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #222222;

      .van-icon {
        margin-left: 10px;
      }
    }

    .uploader-header {
      display: inline-flex;
      width: 100%;
      justify-content: space-between;
      font-size: 32px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #666666;
      margin-top: 40px;
    }

    .scan {
      font-size: 32px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #2f974c;
    }

    .van-field__label {
      margin-top: 10px;
    }

    .van-cell {
      font-size: 32px;
      padding: 0;
      margin-top: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #ebebeb;
      line-height: 34px;
    }

    .uploader-box {
      width: 212px;
      height: 212px;
      background: #f2f5f3;
      opacity: 1;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .add-icon {
        width: 120px;
        height: 120px;
      }

      .text {
        font-size: 32px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #aeb2b8;
      }
    }
  }

  .foot {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 112px;
    background: #ffffff;
    box-shadow: 0px 3px 28px rgba(80, 204, 115, 0.1);
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    .switch-btn {
      width: 160px;
      height: 80px;
      background: linear-gradient(330deg, #2fb555 0%, #50cc73 100%);
      opacity: 1;
      border-radius: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 32px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;

      .code-icon {
        width: 40px;
        height: 40px;
        margin-right: 16px;
      }
    }
    .bt {
      width: 160px;
      height: 80px;
      background: linear-gradient(330deg, #2fb555 0%, #50cc73 100%);
      opacity: 1;
      border-radius: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 32px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
    }
  }

  .uploader-container {
    display: flex;
    align-items: center; /* 垂直居中对齐 */
    gap: 16px; /* 子元素之间的间距，可根据需要调整 */
    flex-wrap: wrap; /* 在小屏幕上允许换行 */
  }

  .uploader-title {
    font-weight: bold; /* 如果需要加粗标题 */
    white-space: nowrap; /* 防止标题换行 */
    font-size: 32px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    line-height: 46px;
    color: #222222;
    padding-top: 32px;
  }

  /* 可选：调整上传组件的宽度以适应布局 */
  .van-uploader {
    flex: 1; /* 使上传组件占据剩余空间 */
    min-width: 200px; /* 设置最小宽度，防止在小屏幕上过窄 */
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/my/CreateProduct.vue